import { Link } from 'react-router-dom';
import { useI18n } from '@/i18n/LanguageContext';

const NotFound = () => {
  const { t, path, lang } = useI18n();

  return (
    <div className="mx-auto flex max-w-lg flex-col items-center px-4 py-24 text-center">
      <p className="text-6xl font-extrabold text-slate-900">404</p>
      <p className="mt-4 text-lg text-slate-600">
        {lang === 'es' ? 'No encontramos esa página.' : 'We could not find that page.'}
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link to={path('/')} className="rounded-xl bg-slate-900 px-6 py-3.5 text-base font-bold text-white hover:bg-slate-800">
          {lang === 'es' ? 'Ir al inicio' : 'Go home'}
        </Link>
        <Link to={path('/jobs')} className="rounded-xl border border-slate-300 px-6 py-3.5 text-base font-bold text-slate-800 hover:bg-slate-50">
          {t('jobs.title')}
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
